import { render, staticRenderFns } from "./TheFooterPaymentMethods.vue?vue&type=template&id=f633ee58&scoped=true"
import script from "./TheFooterPaymentMethods.vue?vue&type=script&lang=js"
export * from "./TheFooterPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./TheFooterPaymentMethods.vue?vue&type=style&index=0&id=f633ee58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f633ee58",
  null
  
)

export default component.exports